import React from 'react'
import Snackbar from '@mui/material/Snackbar'
import MuiAlert from '@mui/material/Alert'
import { useAppDispatch, useAppSelector } from 'src/store/index'
import { handleSnackbarClose } from 'src/store/slice/RootSnackbarSlice'

const refFn = (props, ref) => <MuiAlert ref={ref} {...props} />
const Alert = React.forwardRef(refFn)

const RootSnackbar = () => {
  const { open, message, severity } = useAppSelector((state) => state.RootSnackbarSlice)
  const dispatch = useAppDispatch()
  const handleClose = () => {
    dispatch(handleSnackbarClose())
  }
  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      autoHideDuration={3e3}
      open={open}
      onClose={handleClose}
    >
      <Alert elevation={6} variant="filled" onClose={handleClose} severity={severity || 'success'}>
        {message}
      </Alert>
    </Snackbar>
  )
}

export default RootSnackbar

